import { InputCalendar } from '../core/components/Index';
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Mail } from 'lucide-react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Container } from '../core/components/containers/Container';
import { InputSwitch } from 'primereact/inputswitch';
import { Link } from 'react-router-dom';
import { Accordion, AccordionTab } from 'primereact/accordion';


const ComponentsView: React.FC = () => {
  const accountSummary = [
    {
      title: 'Member Since',
      value: 'November 7, 1989',
    },
    {
      title: 'Current Status',
      value: 'Active',
    },
    {
      title: 'Current Plan',
      value: 'Miscellaneous Tier III',
    },
    {
      title: 'Current Employer',
      value: 'Sacramento County',
    },
    {
      title: 'Employee ID',
      value: '01084322',
    },
    {
      title: 'SSN',
      value: 'XXX-XX-1234',
    },
  ];

  const [selectedCities, setSelectedCities] = useState(null);
  const [value, setValue] = useState('');
  const cities = [
    { name: 'New York', code: 'NY' },
    { name: 'Rome', code: 'RM' },
    { name: 'London', code: 'LDN' },
    { name: 'Istanbul', code: 'IST' },
    { name: 'Paris', code: 'PRS' },
  ];

  return (
    <div>
      {/* <Container>
<TabView>

    <TabPanel header="Components">
       <div>Components</div>
    </TabPanel>
    <TabPanel header="Layouts">
        <p className="m-0">
   Layouts
        </p>
    </TabPanel>
     
    
    </TabView>
    </Container> */}


      <Container className="space-y-6 py-12">
        <h1 className="text-2xl font-bold mb-1">SCERS Component Library</h1>
        <p className="text-gray-600">This is a list of components used in SCERS</p>
        <div className="p-8 bg-gray-50 rounded-xl">
          <h3 className="font-semibold text-lg mb-3">Buttons</h3>

          <div className="flex flex-wrap gap-4">
            <Button label="Primary" />
            <Button>
              {' '}
              <Mail className="mr-2 h-4 w-4  " /> Primary Button with Icon
            </Button>
            <Button label="Warning button" severity="warning" />
            <Button label="Warning link" severity="warning" text />

            <Button label="Info Button" severity="info" />
            <Button label="Danger button" severity="danger" />
            <Button label="Secondary button outlined" severity="secondary" outlined />
          </div>
        </div>

        <div className="p-8  bg-gray-50 rounded-xl">
          <h3 className="font-semibold text-lg mb-3">Dropdown Select</h3>
          <div className="flex flex-col gap-4">
            <Dropdown
              value={selectedCities}
              onChange={(e) => setSelectedCities(e.value)}
              options={cities}
              optionLabel="name"
              placeholder="Select a City"
              className="w-full md:w-14rem"
            />
          </div>
        </div>
        <div className="p-8  bg-gray-50 rounded-xl">
          <h3 className="font-semibold text-lg mb-3">Switch</h3>
          <div className="flex flex-col gap-4">
            <div className="flex align-items-center">
              <InputSwitch inputId="switchid2" checked={true} onChange={(e) => console.log(e.value)} />

              <label htmlFor="switchid2" className="ml-4">
                Associate Membership
              </label>
            </div>
            <div className="flex align-items-center">
              <InputSwitch inputId="switchid1" checked={false} onChange={(e) => console.log(e.value)} />
              <label htmlFor="switchid1" className="ml-4">
                I understand the payment will continue until it is specifically revoked or changed by me and that the amount of dues may be changed by
                the SCREA Board of Directors in accordance with the bylaws. I further authorize SCERS to release my name and address to SCREA while I
                am a dues paying member. This information will remain confidential.
              </label>
            </div>{' '}
          </div>
        </div>
        <div className="p-8  bg-gray-50 rounded-xl">
          <h3 className="font-semibold text-lg mb-3">Checkbox</h3>
          <div className="flex flex-col gap-4">
            <div className="flex align-items-center">
              <Checkbox inputId="id2" value="Associate" checked={false} />
              <label htmlFor="id2" className="ml-4">
                Associate Membership
              </label>
            </div>
            <div className="flex align-items-center">
              <Checkbox inputId="id1" value="agree" checked={true} />
              <label htmlFor="id1" className="ml-4">
                I understand the payment will continue until it is specifically revoked or changed by me and that the amount of dues may be changed by
                the SCREA Board of Directors in accordance with the bylaws. I further authorize SCERS to release my name and address to SCREA while I
                am a dues paying member. This information will remain confidential.
              </label>
            </div>{' '}
          </div>
        </div>

        <div className="p-8  bg-gray-50 rounded-xl">
          <label className="font-semibold text-lg mb-3" htmlFor="demo-cal">Input Calendar</label>
          <div className="flex flex-col gap-4">

            <div className="max-w-md ">
              {/* <InputCalendar value={new Date()} id='demo-cal' className='w-full' /> */}
              <label>
                I understand the payment will continue until it is specifically revoked or changed by me and that the amount of dues may be changed by
                the SCREA Board of Directors in accordance with the bylaws. I further authorize SCERS to release my name and address to SCREA while I
                am a dues paying member. This information will remain confidential.
              </label>
            </div>{' '}
          </div>
        </div>
      </Container>


      <Container>

        <Accordion activeIndex={0}>
          <AccordionTab header="Header I">
            <p className="m-0">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
              commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
          </AccordionTab>
          <AccordionTab header="Header II">
            <p className="m-0">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
              quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas
              sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
              Consectetur, adipisci velit, sed quia non numquam eius modi.
            </p>
          </AccordionTab>
          <AccordionTab header="Header III">
            <p className="m-0">
              At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti
              quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt
              mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio.
              Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.
            </p>
          </AccordionTab>
        </Accordion>

      </Container>

      <Container className="py-12 space-y-8">
        <div className="card">
          <DataTable value={customers} paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }}>
            <Column field="name" header="Name" style={{ width: '25%' }}></Column>
            <Column field="country.name" header="Country" style={{ width: '25%' }}></Column>
            <Column field="company" header="Company" style={{ width: '25%' }}></Column>
            <Column field="representative.name" header="Representative" style={{ width: '25%' }}></Column>
          </DataTable>
        </div>

        <h1 className="text-3xl	font-semibold">Hello, George</h1>

        <div className="grid grid-cols-1  md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded border border-neutral-300">
            <h2 className="text-xl font-semibold mb-4">Account Summary</h2>

            <dl>
              {accountSummary.map((item, index) => (
                <div key={index} className="  py-1.5 flex items-center justify-between">
                  <dt className="text-sm font-medium leading-6 text-gray-900">{item.title}</dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 text-right">{item.value}</dd>
                </div>
              ))}
            </dl>
          </div>
          <div className="gap-4 flex flex-col">
            <div className="bg-white p-6 rounded border border-neutral-300">
              <h2 className="text-xl font-semibold mb-4">Service Credit</h2>
              <p className="text-4xl font-semibold pt-2 text-center text-neutral-600">8.2570</p>
              <p className="text-center py-2  text-neutral-600">Years</p>
            </div>
            <div className="bg-white p-6 rounded border border-neutral-300">
              <h2 className="text-xl font-semibold mb-4">Vesting Status</h2>
              <p className="text-base font-medium py-2  text-neutral-500">Congratulations, you are fully vested!</p>
            </div>
          </div>
          <div className="bg-cream-50 p-6 rounded border border-neutral-300">
            <h2 className="text-xl font-semibold mb-4 text-primary-500">Retirement Calculator</h2>
            <svg width="164" height="46" viewBox="0 0 164 46" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-9 mx-auto my-8">
              <g clip-path="url(#clip0_4441_13568)">
                <path
                  d="M46.875 7.1875C46.875 8.80469 45.5902 10.2961 43.425 11.5C40.8105 12.9465 36.9113 13.9707 32.4371 14.2762C32.1047 14.1145 31.7723 13.9617 31.4219 13.827C27.882 12.3445 23.1742 11.5 18.125 11.5C17.3793 11.5 16.6516 11.518 15.9238 11.5539L15.825 11.5C13.6598 10.2961 12.375 8.80469 12.375 7.1875C12.375 3.21641 20.1016 0 29.625 0C39.1484 0 46.875 3.21641 46.875 7.1875ZM15.3129 14.4738C16.2293 14.4109 17.1727 14.375 18.125 14.375C23.7133 14.375 28.6727 15.4801 31.8262 17.1961C34.0543 18.409 35.375 19.9184 35.375 21.5625C35.375 21.9219 35.3121 22.2723 35.1863 22.6137C34.773 23.7996 33.659 24.8867 32.0418 25.8031C32.0328 25.8121 32.0148 25.8121 32.0059 25.8211C31.9789 25.8391 31.952 25.848 31.925 25.866C28.7805 27.609 23.7672 28.741 18.125 28.741C12.7703 28.741 7.98164 27.7258 4.81016 26.1266C4.63945 26.0457 4.47773 25.9559 4.31602 25.866C2.15977 24.6711 0.875 23.1797 0.875 21.5625C0.875 18.4359 5.67266 15.7676 12.375 14.7883C13.3184 14.6535 14.2977 14.5457 15.3129 14.4738ZM38.25 21.5625C38.25 19.5949 37.2977 17.9777 36.0848 16.7648C38.6273 16.3695 40.9543 15.7406 42.9309 14.923C44.3953 14.3121 45.7609 13.5574 46.875 12.632V15.8125C46.875 17.5465 45.3926 19.1457 42.9398 20.3855C41.6281 21.0504 40.0289 21.6164 38.232 22.0477C38.241 21.8859 38.25 21.7332 38.25 21.5715V21.5625ZM35.375 30.1875C35.375 31.8047 34.0902 33.2961 31.925 34.5C31.7633 34.5898 31.6016 34.6707 31.4309 34.7605C28.2684 36.3598 23.4797 37.375 18.125 37.375C12.4828 37.375 7.46953 36.243 4.325 34.5C2.15977 33.2961 0.875 31.8047 0.875 30.1875V27.007C1.99805 27.9324 3.35469 28.6871 4.81914 29.298C8.36797 30.7805 13.0758 31.625 18.125 31.625C23.1742 31.625 27.882 30.7805 31.4309 29.298C32.1316 29.0105 32.8055 28.6781 33.4434 28.3188C33.9914 28.0133 34.5035 27.6719 34.9887 27.3125C35.1234 27.2137 35.2492 27.1059 35.375 27.007V27.3125V27.8246V30.1875ZM38.25 30.1875V27.3125V24.9855C39.957 24.6082 41.5293 24.132 42.9309 23.548C44.3953 22.9371 45.7609 22.1824 46.875 21.257V24.4375C46.875 25.3809 46.4258 26.3242 45.5363 27.2137C44.0719 28.6781 41.4934 29.882 38.232 30.6637C38.241 30.5109 38.25 30.3492 38.25 30.1875ZM18.125 40.25C23.1742 40.25 27.882 39.4055 31.4309 37.923C32.8953 37.3121 34.2609 36.5574 35.375 35.632V38.8125C35.375 42.7836 27.6484 46 18.125 46C8.60156 46 0.875 42.7836 0.875 38.8125V35.632C1.99805 36.5574 3.35469 37.3121 4.81914 37.923C8.36797 39.4055 13.0758 40.25 18.125 40.25Z"
                  fill="#557122"
                />
              </g>
              <g clip-path="url(#clip1_4441_13568)">
                <path
                  d="M67.625 0C64.4535 0 61.875 2.57852 61.875 5.75V40.25C61.875 43.4215 64.4535 46 67.625 46H90.625C93.7965 46 96.375 43.4215 96.375 40.25V5.75C96.375 2.57852 93.7965 0 90.625 0H67.625ZM70.5 5.75H87.75C89.3402 5.75 90.625 7.03477 90.625 8.625V11.5C90.625 13.0902 89.3402 14.375 87.75 14.375H70.5C68.9098 14.375 67.625 13.0902 67.625 11.5V8.625C67.625 7.03477 68.9098 5.75 70.5 5.75ZM73.375 20.125C73.375 20.8875 73.0721 21.6188 72.5329 22.1579C71.9938 22.6971 71.2625 23 70.5 23C69.7375 23 69.0062 22.6971 68.4671 22.1579C67.9279 21.6188 67.625 20.8875 67.625 20.125C67.625 19.3625 67.9279 18.6312 68.4671 18.0921C69.0062 17.5529 69.7375 17.25 70.5 17.25C71.2625 17.25 71.9938 17.5529 72.5329 18.0921C73.0721 18.6312 73.375 19.3625 73.375 20.125ZM70.5 31.625C69.7375 31.625 69.0062 31.3221 68.4671 30.7829C67.9279 30.2438 67.625 29.5125 67.625 28.75C67.625 27.9875 67.9279 27.2562 68.4671 26.7171C69.0062 26.1779 69.7375 25.875 70.5 25.875C71.2625 25.875 71.9938 26.1779 72.5329 26.7171C73.0721 27.2562 73.375 27.9875 73.375 28.75C73.375 29.5125 73.0721 30.2438 72.5329 30.7829C71.9938 31.3221 71.2625 31.625 70.5 31.625ZM67.625 37.375C67.625 35.7848 68.9098 34.5 70.5 34.5H79.125C80.7152 34.5 82 35.7848 82 37.375C82 38.9652 80.7152 40.25 79.125 40.25H70.5C68.9098 40.25 67.625 38.9652 67.625 37.375ZM79.125 23C78.3625 23 77.6312 22.6971 77.0921 22.1579C76.5529 21.6188 76.25 20.8875 76.25 20.125C76.25 19.3625 76.5529 18.6312 77.0921 18.0921C77.6312 17.5529 78.3625 17.25 79.125 17.25C79.8875 17.25 80.6188 17.5529 81.1579 18.0921C81.6971 18.6312 82 19.3625 82 20.125C82 20.8875 81.6971 21.6188 81.1579 22.1579C80.6188 22.6971 79.8875 23 79.125 23ZM82 28.75C82 29.5125 81.6971 30.2438 81.1579 30.7829C80.6188 31.3221 79.8875 31.625 79.125 31.625C78.3625 31.625 77.6312 31.3221 77.0921 30.7829C76.5529 30.2438 76.25 29.5125 76.25 28.75C76.25 27.9875 76.5529 27.2562 77.0921 26.7171C77.6312 26.1779 78.3625 25.875 79.125 25.875C79.8875 25.875 80.6188 26.1779 81.1579 26.7171C81.6971 27.2562 82 27.9875 82 28.75ZM87.75 23C86.9875 23 86.2562 22.6971 85.7171 22.1579C85.1779 21.6188 84.875 20.8875 84.875 20.125C84.875 19.3625 85.1779 18.6312 85.7171 18.0921C86.2562 17.5529 86.9875 17.25 87.75 17.25C88.5125 17.25 89.2438 17.5529 89.7829 18.0921C90.3221 18.6312 90.625 19.3625 90.625 20.125C90.625 20.8875 90.3221 21.6188 89.7829 22.1579C89.2438 22.6971 88.5125 23 87.75 23ZM90.625 28.75C90.625 29.5125 90.3221 30.2438 89.7829 30.7829C89.2438 31.3221 88.5125 31.625 87.75 31.625C86.9875 31.625 86.2562 31.3221 85.7171 30.7829C85.1779 30.2438 84.875 29.5125 84.875 28.75C84.875 27.9875 85.1779 27.2562 85.7171 26.7171C86.2562 26.1779 86.9875 25.875 87.75 25.875C88.5125 25.875 89.2438 26.1779 89.7829 26.7171C90.3221 27.2562 90.625 27.9875 90.625 28.75ZM87.75 40.25C86.9875 40.25 86.2562 39.9471 85.7171 39.4079C85.1779 38.8688 84.875 38.1375 84.875 37.375C84.875 36.6125 85.1779 35.8812 85.7171 35.3421C86.2562 34.8029 86.9875 34.5 87.75 34.5C88.5125 34.5 89.2438 34.8029 89.7829 35.3421C90.3221 35.8812 90.625 36.6125 90.625 37.375C90.625 38.1375 90.3221 38.8688 89.7829 39.4079C89.2438 39.9471 88.5125 40.25 87.75 40.25Z"
                  fill="#557122"
                />
              </g>
              <g clip-path="url(#clip2_4441_13568)">
                <path
                  d="M147.312 8.625V8.68789C146.836 8.65195 146.36 8.625 145.875 8.625H134.375C132.893 8.625 131.455 8.81367 130.08 9.16406C130.071 8.98438 130.062 8.80469 130.062 8.625C130.062 3.86328 133.926 0 138.688 0C143.449 0 147.312 3.86328 147.312 8.625ZM145.875 11.5C146.189 11.5 146.504 11.509 146.809 11.527C147.187 11.5539 147.564 11.5898 147.941 11.6438C149.523 9.80195 151.877 8.625 154.5 8.625H155.533C156.468 8.625 157.15 9.50547 156.926 10.4129L155.686 15.3723C157.105 16.702 158.264 18.3191 159.055 20.125H160.25C161.84 20.125 163.125 21.4098 163.125 23V31.625C163.125 33.2152 161.84 34.5 160.25 34.5H157.375C156.557 35.5871 155.587 36.5574 154.5 37.375V43.125C154.5 44.7152 153.215 46 151.625 46H148.75C147.16 46 145.875 44.7152 145.875 43.125V40.25H134.375V43.125C134.375 44.7152 133.09 46 131.5 46H128.625C127.035 46 125.75 44.7152 125.75 43.125V37.375C122.614 35.0211 120.476 31.4184 120.072 27.3125H117.484C114.106 27.3125 111.375 24.5812 111.375 21.2031C111.375 17.825 114.106 15.0938 117.484 15.0938H117.844C119.039 15.0938 120 16.0551 120 17.25C120 18.4449 119.039 19.4062 117.844 19.4062H117.484C116.496 19.4062 115.688 20.2148 115.688 21.2031C115.688 22.1914 116.496 23 117.484 23H120.287C121.375 17.6273 125.471 13.3418 130.736 11.9672C131.895 11.6617 133.117 11.5 134.375 11.5H145.875ZM151.625 23.7188C151.625 23.1469 151.398 22.5984 150.993 22.194C150.589 21.7897 150.041 21.5625 149.469 21.5625C148.897 21.5625 148.348 21.7897 147.944 22.194C147.54 22.5984 147.312 23.1469 147.312 23.7188C147.312 24.2906 147.54 24.8391 147.944 25.2434C148.348 25.6478 148.897 25.875 149.469 25.875C150.041 25.875 150.589 25.6478 150.993 25.2434C151.398 24.8391 151.625 24.2906 151.625 23.7188Z"
                  fill="#557122"
                />
              </g>
              <defs>
                <clipPath id="clip0_4441_13568">
                  <rect width="46" height="46" fill="white" transform="translate(0.875)" />
                </clipPath>
                <clipPath id="clip1_4441_13568">
                  <rect width="34.5" height="46" fill="white" transform="translate(61.875)" />
                </clipPath>
                <clipPath id="clip2_4441_13568">
                  <rect width="51.75" height="46" fill="white" transform="translate(111.375)" />
                </clipPath>
              </defs>
            </svg>
            <p className="text-sm font-medium  text-neutral-600">
              {' '}
              Estimate your future pension benefits today! Use our Retirement Benefit Calculator and plan your retirement with confidence.
            </p>
            <div className="border-t mt-4 pt-4 flex justify-center">
              <Button>Start Your Estimate</Button>
            </div>
          </div>
          <div className="bg-cream-50 p-6 rounded border border-neutral-300">
            <h2 className="text-xl font-semibold mb-4 text-primary-500">Apply for Service Retirement</h2>

            <svg className="h-9 mx-auto my-8" viewBox="0 0 132 46" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M42.9266 1.49105C40.9386 -0.497015 37.725 -0.497015 35.7369 1.49105L33.0045 4.21442L41.8917 13.1017L44.6242 10.3692C46.6122 8.38117 46.6122 5.1676 44.6242 3.17953L42.9266 1.49105ZM15.7655 21.4624C15.2118 22.0162 14.7851 22.697 14.54 23.4505L11.853 31.5117C11.5897 32.2924 11.7985 33.1548 12.3795 33.7448C12.9605 34.3349 13.8229 34.5346 14.6126 34.2714L22.6738 31.5843C23.4182 31.3392 24.0991 30.9125 24.6619 30.3588L39.8492 15.1624L30.9529 6.26602L15.7655 21.4624ZM8.83002 5.331C4.01873 5.331 0.115234 9.2345 0.115234 14.0458V37.2852C0.115234 42.0965 4.01873 46 8.83002 46H32.0695C36.8807 46 40.7842 42.0965 40.7842 37.2852V28.5704C40.7842 26.9636 39.4861 25.6655 37.8793 25.6655C36.2725 25.6655 34.9744 26.9636 34.9744 28.5704V37.2852C34.9744 38.892 33.6762 40.1901 32.0695 40.1901H8.83002C7.22323 40.1901 5.92509 38.892 5.92509 37.2852V14.0458C5.92509 12.439 7.22323 11.1409 8.83002 11.1409H17.5448C19.1516 11.1409 20.4497 9.84272 20.4497 8.23593C20.4497 6.62914 19.1516 5.331 17.5448 5.331H8.83002Z"
                fill="#557122"
              />
              <path
                d="M66.4229 0C63.4926 0 61.1152 2.3774 61.1152 5.30769C61.1152 6.9774 61.9003 8.5476 63.2383 9.55385L87.2999 27.6C88.5604 28.5399 90.2854 28.5399 91.546 27.6L97.8931 22.8452C100.536 16.2327 106.706 11.4226 114.071 10.7038L115.608 9.55385C116.946 8.5476 117.731 6.9774 117.731 5.30769C117.731 2.3774 115.353 0 112.423 0H66.4229ZM93.6691 30.4308C91.1479 32.3216 87.6979 32.3216 85.1768 30.4308L61.1152 12.3846V35.3846C61.1152 39.288 64.2888 42.4615 68.1922 42.4615H100.945C98.1696 39.1 96.4999 34.7764 96.4999 30.0769C96.4999 29.4577 96.533 28.8495 96.5883 28.2413L93.6691 30.4308ZM131.884 30.0769C131.884 25.8539 130.207 21.8038 127.221 18.8176C124.235 15.8315 120.184 14.1538 115.961 14.1538C111.738 14.1538 107.688 15.8315 104.702 18.8176C101.716 21.8038 100.038 25.8539 100.038 30.0769C100.038 34.3 101.716 38.3501 104.702 41.3362C107.688 44.3224 111.738 46 115.961 46C120.184 46 124.235 44.3224 127.221 41.3362C130.207 38.3501 131.884 34.3 131.884 30.0769ZM123.403 25.2889C124.089 25.9745 124.089 27.1024 123.403 27.788L115.442 35.7495C114.756 36.4351 113.628 36.4351 112.943 35.7495L108.52 31.3264C107.834 30.6409 107.834 29.513 108.52 28.8274C109.205 28.1418 110.333 28.1418 111.019 28.8274L114.192 32.001L120.904 25.2889C121.59 24.6034 122.718 24.6034 123.403 25.2889Z"
                fill="#557121"
              />
            </svg>

            <p className="text-sm font-medium  text-neutral-600">
              {' '}
              Begin your retirement journey with ease! Submit your retirement application and take the first step towards a well-deserved future.
            </p>
            <div className="border-t mt-4 pt-4 flex justify-center">
              <Button link>
                <Link to={'/ora/getting-started'}>Apply for Service Retirement</Link>
              </Button>
            </div>
          </div>
        </div>
        <div className="bg-orange-400 h-[1px] w-full  " />
        <div>
          <h2 className="text-xl font-semibold mb-4 ">Service Credit History</h2>
          {serviceCreditHistory.plans.map((plan, index) => (
            <div key={index} className=" my-8 ">
              <h3 className="text-lg font-semibold mb-2">{plan.name}</h3>
              <h3 className="text-base font-normal text-neutral-600 mb-4">{plan.years} years</h3>
              <div className="grid grid-cols-3 gap-6">
                {plan.details.map((detail, index) => (
                  <div className="border border-neutral-300 p-6 text-neutral-600 space-y-4" key={index}>
                    <h4 className="font-semibold text-neutral-800 mb-4 text-xl">{detail.type}</h4>
                    <div className="flex items-center justify-between">
                      <p>Regular</p>
                      <p>{detail.regular}</p>
                    </div>
                    <div className="flex items-center justify-between">
                      <p>Cost of Living</p>
                      <p>{detail.costOfLiving}</p>
                    </div>
                    <div className="border-t pt-4">
                      <div className="flex items-center justify-between">
                        <p>Total</p>
                        <p>{detail.total}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default ComponentsView;

const serviceCreditHistory = {
  plans: [
    {
      name: 'Miscellaneous Tier III - Current Plan',
      years: 5.3203,
      details: [
        {
          type: 'Contributions',
          regular: '$#,###,###.##',
          costOfLiving: '$#,###,###.##',
          total: '$#,###,###.##',
        },
        {
          type: 'Interest',
          regular: '$#,###,###.##',
          costOfLiving: '$#,###,###.##',
          total: '$#,###,###.##',
        },
        {
          type: 'Contributions & Interest',
          regular: '$#,###,###.##',
          costOfLiving: '$#,###,###.##',
          total: '$#,###,###.##',
        },
      ],
    },
    {
      name: 'Safety Tier IV',
      years: 5.3203,
      details: [
        {
          type: 'Contributions',
          regular: '$#,###,###.##',
          costOfLiving: '$#,###,###.##',
          total: '$#,###,###.##',
        },
        {
          type: 'Interest',
          regular: '$#,###,###.##',
          costOfLiving: '$#,###,###.##',
          total: '$#,###,###.##',
        },
        {
          type: 'Contributions & Interest',
          regular: '$#,###,###.##',
          costOfLiving: '$#,###,###.##',
          total: '$#,###,###.##',
        },
      ],
    },
  ],
};

export const customers = [
  {
    id: 1000,
    name: 'James Joe',
    country: {
      name: 'Algeria',
      code: 'dz',
    },
    company: 'Benton, John B Jr',
    date: '2015-09-13',
    status: 'unqualified',
    verified: true,
    activity: 17,
    representative: {
      name: 'Ioni Bowcher',
      image: 'ionibowcher.png',
    },
    balance: 70663,
  },
  //fake data with unique names id and country
  {
    id: 1001,
    name: 'Sally Smith',
    country: {
      name: 'Algeria',
      code: 'dz',
    },
    company: 'Benton, John B Jr',
    date: '2015-09-13',
    status: 'unqualified',
    verified: true,
    activity: 17,
    representative: {
      name: 'Ioni Bowcher',
      image: 'ionibowcher.png',
    },
    balance: 70663,
  },
  {
    id: 1002,
    name: 'John Doe',
    country: {
      name: 'Algeria',
      code: 'dz',
    },
    company: 'Benton, John B Jr',
    date: '2015-09-13',
    status: 'unqualified',
    verified: true,
    activity: 17,
    representative: {
      name: 'Ioni Bowcher',
      image: 'ionibowcher.png',
    },
    balance: 70663,
  },
  {
    id: 1003,
    name: 'Jane Doe',
    country: {
      name: 'Algeria',
      code: 'dz',
    },
    company: 'Benton, John B Jr',
    date: '2015-09-13',
    status: 'unqualified',
    verified: true,
    activity: 17,
    representative: {
      name: 'Ioni Bowcher',
      image: 'ionibowcher.png',
    },
    balance: 70663,
  },
  {
    id: 1004,
    name: 'James Joe',
    country: {
      name: 'Algeria',
      code: 'dz',
    },
    company: 'Benton, John B Jr',
    date: '2015-09-13',
    status: 'unqualified',
    verified: true,
    activity: 17,
    representative: {
      name: 'Ioni Bowcher',
      image: 'ionibowcher.png',
    },
    balance: 70663,
  },
  {
    id: 1005,
    name: 'Sally Smith',
    country: {
      name: 'Algeria',
      code: 'dz',
    },
    company: 'Benton, John B Jr',
    date: '2015-09-13',
    status: 'unqualified',
    verified: true,
    activity: 17,
    representative: {
      name: 'Ioni Bowcher',
      image: 'ionibowcher.png',
    },
    balance: 70663,
  },
];
